import decodeUriComponent from 'decode-uri-component';
import Ad from './Ad';
import ReactModal  from 'react-modal';
import { useEffect, useState } from 'react';
import Btn from './Button';
import External from './Extrenal';
import { useTranslation } from 'react-i18next';
import {getStories} from '../helpers/Utils';
import {  Link } from "react-router-dom";

const CurrentStory = (props) => {
    const [isPopupOpen, setPopupIsOpen] = useState(false);
    const [currentStory, setCurrentStory] = useState(false);
    const [currentTitle, setCurrentTitle] = useState(false);
    const [currentImg, setCurrentImg] = useState(false);
    const [currentHref, setCurrentHref] = useState(false);
    const [currentIsVideo, setCurrentIsVideo] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isOpen, setForumIsOpen] = useState(false);
    const [stories, setStories] = useState([]);
    const { t } = useTranslation();
    const openDetails = (title_alert, text_alert, img_alert, href_alert, isVideo) => {
      setCurrentStory(text_alert);
      setCurrentTitle(title_alert);
      setCurrentImg(img_alert);
      setCurrentHref(href_alert);
      setCurrentIsVideo(isVideo);
      setPopupIsOpen(true);
    }
    const toggleOpen = () => {
        
        setForumIsOpen(!isOpen);
      }
    useEffect(() =>{
      const fetchStories = async () => {
        const stories_str = await getStories();
        console.log("stories: " + stories_str);
        setStories(stories_str.jws.Stories);
    };
      const handleResize = () => {
                setScreenWidth(window.innerWidth);
                //alert(window.innerWidth);
    
            };
            
            handleResize();
            window.addEventListener('resize', handleResize);
        fetchStories();
      // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('resize', handleResize);
            };
  }, [])
  if (props.lang === undefined)
      return "loading...";
    
  const customStyles = {
    content: {
  
      width:(screenWidth > 800 ) ? '420px' :'100%',
      padding: '10px',
      top: '0',
      left: '0',
      direction: (props.lang == 1) ? 'rtl' : '',
      right: 'auto',
      bottom: '0',
      position: 'absolute',
      marginRight: '',
      transform: '',
    },
  };
  const customStylesCurrentStory = {
    content: {
      
      width:(screenWidth > 800 ) ? '420px' :'100%',
      padding: '12px',
      top: '50%',
      left: '50%',
      direction: (props.lang == 1) ? 'rtl' : '',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
     

    return (
        (stories == "") ? 'loading stories' :
        <div className=" white_transp_box white_box">
        <h4 id="current_story_title">{t('CURRENT_STORY')}</h4>       
        <div id="stories" className={" d-grid align-items-center justify-items-center justify-content-center  " + (props.lang == 1? 'rtl textright' : 'textleft')} >
        {stories.map((story, i) => {
          var isVideo = (eval(`story.img_src${props.lang}`).indexOf("mp4") > 0);
          var isImg = ((eval(`story.img_src${props.lang}`) !== "") && (eval(`story.img_src${props.lang}`).indexOf("mp4") < 0));
          let img_alert = eval(`story.img_src${props.lang}`);
          let href_alert = eval(`story.href${props.lang}`);
          let text_alert = decodeUriComponent(eval(`story.Description${props.lang}`)).replace(/\+/g, ' ').replace(/(\r\n|\r|\n)/g, '<br/>');
          let title_alert = decodeUriComponent(eval(`story.Title${props.lang}`)).replace(/\+/g, ' ');
          let short_text_alert = text_alert.substring(0,100) + "...";
        return  (
                <div className=" story" key={i}  a_key={i}>
                  
                 <div className="text_title">{title_alert}</div>
                 { isImg && <img src={eval(`story.img_src${props.lang}`)} width="320" alt="" className="rounded "/>}
                 { isVideo && <video width="310" height="240" controls><source src={eval(`story.img_src${props.lang}`)} type="video/mp4" /></video>}      
                  <Link  onClick={() => openDetails(title_alert, text_alert, img_alert, href_alert, isVideo)} >
                  <div className="white_box"><div className="text_notification" dangerouslySetInnerHTML={{__html: short_text_alert}}></div></div>         
                
                </Link>  
               
            </div>
        )
            
        
        })}
         <Btn btnOnClick={() => toggleOpen(true)} btnTitleText={t("CHAT_TITLE")}  img={(props.lang == 1)? "ArrowLeft" : "ArrowRight"}>
                
          </Btn> 
      </div>
       <ReactModal
        isOpen={isPopupOpen}
        contentLabel="Example Modal"
        style={customStylesCurrentStory}
        onRequestClose={() => setPopupIsOpen(false)}
      >
         <Btn
          btnOnClick={() => setPopupIsOpen(false)}
          btnTitleText={""}
          img={"X"}
          cssClasses="float-start"
        ></Btn>
         
        <div className="text_title">{currentTitle}</div>
        <div className="white_box"><img src={currentImg} width="320" alt="" /></div>
        <div className="text_notification" dangerouslySetInnerHTML={{__html: currentStory}}></div>
        <br/>
        <a href={currentHref} target="_blank">{t('LINK')}</a>
         <br/>  
        <br/>
        <Btn btnOnClick={() => setPopupIsOpen(false)} btnTitleText={"Ok"}></Btn>
      </ReactModal>
      <ReactModal
        
        isOpen={isOpen}
        contentLabel="Example Modal"
        style={customStyles}
        onRequestClose={() => toggleOpen(false)}

      >
         <Btn btnOnClick={() => toggleOpen(false)} btnTitleText={""}  img={"X"} cssClasses="float-start">
                
        </Btn>
        <div className="sidepopup">
        <External src={"https://v2013.02ws.co.il/small/?section=chatmobile.php&lang=" + props.lang} width="400" height="95%" className={props.cssClasses}/>
        </div>
      </ReactModal>
    </div>
    );
}

export default CurrentStory; 